import '@/global.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { CompoundsProvider } from '@/lib/state/compounds';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById('root')!;
createRoot(rootEl).render(
  <React.StrictMode>
    <SafeAreaProvider>
      <CompoundsProvider>
        <RouterProvider router={router} />
      </CompoundsProvider>
    </SafeAreaProvider>
  </React.StrictMode>,
);
